import axios from 'axios'

export default {
    get: (params = {}) => axios.get('asset-types', { params }),
    getPublic: () => axios.get('asset-types-public'),
    store: (data) => axios.post('asset-types/store', data),
    update: (data) => axios.post('asset-types/update', data),
    delete: (id) => axios.post('asset-types/delete', id)
}